// DHL Service Point Partner Lite'ın "Lütfen Paket Türü Seçin" listesindeki
// hazır ambalajlar. Ölçüler cm, ağırlık kg.
//
// Zarfta ağırlık kullanıcıdan alınır (DHL'de de öyle); kutularda ambalajın
// kendi ağırlığı kullanılır ve ağırlık alanı gösterilmez.
const DHLPackageTypes = [
  {
    value: 'DHL ENVELOPE NO 1 - ZARF',
    label: 'DHL ENVELOPE NO 1 - ZARF',
    weight: 0.1,
    length: 28,
    width: 35,
    height: 1,
    isEnvelope: true,
  },
  {
    value: 'DHL BOX NO 2 - KUTU 2',
    label: 'DHL BOX NO 2 - KUTU 2',
    weight: 1,
    length: 18.2,
    width: 33.7,
    height: 10,
  },
  {
    value: 'DHL BOX NO 3 - KUTU 3',
    label: 'DHL BOX NO 3 - KUTU 3',
    weight: 2,
    length: 32.2,
    width: 33.7,
    height: 10,
  },
  {
    value: 'DHL BOX NO 4 - KUTU 4',
    label: 'DHL BOX NO 4 - KUTU 4',
    weight: 5,
    length: 32.2,
    width: 33.7,
    height: 18,
  },
  {
    value: 'DHL BOX NO 5 - KUTU 5',
    label: 'DHL BOX NO 5 - KUTU 5',
    weight: 10,
    length: 32.2,
    width: 33.7,
    height: 34.5,
  },
  {
    value: 'DHL BOX NO 6 - KUTU 6',
    label: 'DHL BOX NO 6 - KUTU 6',
    weight: 15,
    length: 35.9,
    width: 41.7,
    height: 36.9,
  },
  {
    value: 'DHL BOX NO 7 - KUTU 7',
    label: 'DHL BOX NO 7 - KUTU 7',
    weight: 20,
    length: 40.4,
    width: 48.4,
    height: 38.9,
  },
  {
    value: 'DHL BOX NO 8 - KUTU 8',
    label: 'DHL BOX NO 8 - KUTU 8',
    weight: 25,
    length: 44.4,
    width: 54.1,
    height: 40.9,
  },
];

// DHL'in listede gösterdiği biçim: "DHL BOX NO 5 - KUTU 5 [10KG] (32.2X33.7X34.5)"
export function getPackageTypeLabel(type) {
  if (!type) return '';
  const dimensions = `${type.length}X${type.width}X${type.height}`;
  return `${type.label} [${type.weight}KG] (${dimensions})`;
}

export function findPackageType(value) {
  return DHLPackageTypes.find((type) => type.value === value) || null;
}

export default DHLPackageTypes;
